import styles from "../../../pages/subscriptions/mySubscription/MySubscription.module.css";
import { useNavigate } from "react-router-dom";

export default function GamesPromo({ t }) {
  const navigate = useNavigate();

  return (
    <div className={styles.promoWrapper} onClick={() => navigate("/games")}>
      <div className={styles.promoContent}>
        <span className={styles.promoTitle}>{t("promo_kids_more_fun_title")}</span>
        <span className={styles.promoText}>{t("promo_kids_fun_games_desc")}</span>
        <div className={styles.promoImages}>
          <div className={styles.promoCard}>
            <img src="/assets/intro/puzzleScreen.png" alt="" />
          </div>
          <div className={styles.promoCard}>
            <img src="/assets/intro/paintingScreen.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};